import { render } from "./touchspinWithIcon.vue?vue&type=template&id=573de8a5"
import script from "./touchspinWithIcon.vue?vue&type=script&lang=js"
export * from "./touchspinWithIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__